import { makeAutoObservable, runInAction } from "mobx";
import { getRoot } from "mobx-easy";

import RegularsService from "../../services/RegularsService";

export default class RegularsStore {
	entries = [];
	rooms = [];
	total = 0;
	page = 1;
	pages = 0;
	limit = 50;

	constructor() {
		makeAutoObservable(this);
	}

	clearRegularsStore = () => {
		this.entries = [];
		this.rooms = [];
		this.total = 0;
		this.page = 1;
		this.pages = 0;
		this.limit = 50;
	};

	getRegularsList = async ({
		roomCode = null,
		email = null,
		page = this.page,
		limit = this.limit,
		exportAll = false,
	} = {}) => {
		this.rootStore.uiStore.startLoading();

		try {
			const response = await RegularsService.getRegularsList({
				roomCode: roomCode || null,
				email: email || null,
				page,
				limit,
				exportAll,
			});

			if (!exportAll) {
				runInAction(() => {
					this.entries = response.entries || [];
					this.rooms = response.rooms || [];
					this.total = response.total || 0;
					this.page = response.page || page;
					this.pages = response.pages || 0;
					this.limit = response.limit || limit;
				});
			}

			return response;
		} finally {
			runInAction(() => {
				this.rootStore.uiStore.cancelLoading();
			});
		}
	};

	get rootStore() {
		return getRoot();
	}
}
